import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Cell from '../Cell';
import { getNumberOfDaysBreakPoint, getStyleForShiftId } from '../../../libs/calendarConfig';
import Shift from '../../../components/FleetCalendar/Cells/Shift';

function styles() {
	return {
		editHover: {
			position: 'absolute',
			left: 0,
			right: 0,
			top: 0,
			bottom: 0,
			transition: '0.3s',
			cursor: 'pointer',
			border: '1px solid rgba(255,255,255,.1)',
			zIndex: 100,
			'&:hover': {
				border: '1px solid rgba(32,150,243,.8)',
				backgroundColor: `rgba(32,150,243,.2)`,
			},
		},
		addTruckContainer: {
			backgroundColor: '#d2d2d229', //-overridden
			color: '#888888', //- overridden
			fontWeight: 500,
			fontSize: 13,
			display: 'flex',
			margin: `2px 2px`,
			padding: `10px 6px`,
			borderRadius: 1,

			flexDirection: 'row',
			justifyContent: 'center',
			alignItems: 'center',
			position: 'relative',
			textTransform: 'uppercase',
			border: '1px solid rgba(158, 158, 158, 0.28)',
		},
	};
}

class UnavailableTrucks extends Component {
	render() {
		const {
			numberOfDays,
			unavailableTrucks = [],
			equipmentMap,
			className,
			classes,
			onMaintenanceAdd,
			onMaintenanceUpdate,
			date,
		} = this.props;

		const { nodIsLarge } = getNumberOfDaysBreakPoint(numberOfDays);
		const addLabel = nodIsLarge ? 'Add' : 'Add Truck';
		return (
			<Cell numberOfDays={numberOfDays} className={className}>
				<div style={{ position: 'relative' }}>
					<div
						className={classes.editHover}
						onClick={() => {
							onMaintenanceAdd({ dateForAddMaintenance: date });
						}}
					/>
					<div className={classes.addTruckContainer}>{addLabel}</div>
				</div>

				{unavailableTrucks.map((unavailableTruck) => {
					const { unavailableTruckId, equipmentId, status } = unavailableTruck;

					const equipment = equipmentMap[equipmentId] || {
						display: 'missing',
						manufacturerName: '?',
					};
					const style = getStyleForShiftId({ status: 'unavailable' });

					return (
						<div key={unavailableTruckId} style={{ position: 'relative' }}>
							<div
								className={classes.editHover}
								onClick={() => {
									onMaintenanceUpdate({ unavailableTruckId });
								}}
							/>

							<Shift
								key={unavailableTruckId}
								numberOfDays={numberOfDays}
								equipment={equipment}
								style={style}
								equipmentStatus={status}
								showManufacturer={true}
								hideShiftTime={true}
							/>
						</div>
					);
				})}
			</Cell>
		);
	}
}

UnavailableTrucks.propTypes = {
	numberOfDays: PropTypes.number,
	equipmentMap: PropTypes.object.isRequired,
	onMaintenanceUpdate: PropTypes.func.isRequired,
	onMaintenanceAdd: PropTypes.func.isRequired,
};
UnavailableTrucks.defaultProps = {};

export default withStyles(styles)(UnavailableTrucks);
